<knw-frame>
  <router-outlet></router-outlet>
</knw-frame>